"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Name = void 0;
const typeorm_1 = require("typeorm");
class Name {
    static fromDTO(dto) {
        const name = new Name();
        name.first = dto.first;
        name.last = dto.last;
        return name;
    }
}
exports.Name = Name;
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], Name.prototype, "first", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], Name.prototype, "last", void 0);
